export const getCrid = (fallback = null) => {
  try {
    const storage = localStorage.getItem('CRID')
    return storage ? JSON.parse(storage).id : fallback
  } catch {
    return fallback
  }
}

export const formatCurrency = value => {
  if (value === null || value === undefined) return '-'
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}

export const formatDate = dateString => {
  if (!dateString) return '-'
  const parts = String(dateString).match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (parts) {
    const [, year, month, day] = parts
    return `${day}/${month}/${year}`
  }
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return dateString
  return new Intl.DateTimeFormat('pt-BR').format(date)
}

export const formatPercentage = (value, suffix = '') => {
  if (value === null || value === undefined) return '-'
  const formatted = value.toFixed(2).replace('.', ',')
  return suffix ? `${formatted}% ${suffix}` : `${formatted}%`
}

export const formatInstallmentsSummary = (count, value) => {
  if (!count || value === undefined || value === null) return '-'
  return `${count}x de ${formatCurrency(value)}`
}

export const formatCPF = cpf => {
  if (!cpf) return '-'
  const cleaned = cpf.replace(/\D/g, '')
  if (cleaned.length !== 11) return cpf
  return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export const mapSignatureStatus = status => {
  const statusMap = {
    completed: { variant: 'success', text: 'Concluído' },
    pending: { variant: 'warning', text: 'Pendente' }
  }
  return statusMap[status] || statusMap.pending
}

export const cloneCalculationData = calculation => {
  if (!calculation) return null
  return {
    title: calculation.title,
    description: calculation.description,
    totals: {
      overdue: calculation.totals?.overdue,
      future: calculation.totals?.future,
      total: calculation.totals?.total
    },
    installments: calculation.installments?.map(installment => ({
      ...installment,
      details: { ...installment.details }
    }))
  }
}

export const copyToClipboard = async text => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand('copy')
      return true
    } finally {
      document.body.removeChild(textArea)
    }
  }
}

export const getSummaryInfoFromStorage = () => {
  try {
    const storage = localStorage.getItem('sumary_info')
    return storage ? JSON.parse(storage) : null
  } catch {
    return null
  }
}

export const mapStorageToFormattedData = summaryInfo => {
  if (!summaryInfo) return null

  const getPaymentPlanValue = id => {
    const item = summaryInfo.paymentPlan?.find(p => p.id === id)
    return item?.value || null
  }

  const getScheduleDate = id => {
    const item = summaryInfo.schedule?.find(s => s.id === id)
    return item?.date || null
  }

  const mapInstallments = () => {
    const installments = summaryInfo.calculation?.installments
    if (!installments || !Array.isArray(installments)) return null

    const parcelas = []

    const entryValue = getPaymentPlanValue('entry')
    const entryDate = getScheduleDate('entry-due')
    if (entryValue) {
      parcelas.push({
        label: 'Entrada',
        valor: entryValue,
        data: entryDate
      })
    }

    installments.forEach((inst, index) => {
      parcelas.push({
        label: `${index + 1}ª parcela`,
        valor: formatCurrency(inst.amount),
        data: formatDate(inst.details?.dueDate)
      })
    })

    return parcelas
  }

  return {
    saldoDevedorNegociado: summaryInfo.outstanding?.currentValue,
    valorARefinanciar: null,
    validadeDaProposta: null,

    valorEntrada: getPaymentPlanValue('entry'),
    novasParcelasResumo: getPaymentPlanValue('installments'),
    vencimentoPrimeiraParcela: getScheduleDate('first-due'),
    taxaJurosContrato: null,

    dataVencimentoEntrada: getScheduleDate('entry-due'),
    parcelas: mapInstallments(),

    totalPagoAPrazo: getPaymentPlanValue('total'),

    termUrl: null,

    saldoDevedorAtual: summaryInfo.outstanding?.currentValue,
    saldoDevedorAnterior: summaryInfo.outstanding?.previousValue,
    percentualDesconto: summaryInfo.discount?.percentage,
    calculation: summaryInfo.calculation,
    quantidadeParcelas: null,
    valorParcela: null,
    dataVencimentoPrimeiraParcela: getScheduleDate('first-due')
  }
}
